import Zoom from "../zoom";

// ===========================================
// ======== Funções comuns de zoom ===========
// ===========================================

// Evento que controla o movimento do zoom ativado na imagem
export function handleMouseMoveZoom(event, imgContainer, zoomedImage) {
  if (Zoom.zoomAnimationFrame) return; // Se houver uma animação pendente, sai da função

  Zoom.zoomAnimationFrame = requestAnimationFrame(() => {
    const rect = imgContainer.getBoundingClientRect();

    const mouseX = (event.clientX - rect.left) / rect.width;
    const mouseY = (event.clientY - rect.top) / rect.height;

    const percentX = mouseX * 100;
    const percentY = mouseY * 100;

    // Define a origem do zoom de acordo com a posição do mouse
    zoomedImage.style.transformOrigin = `${percentX}% ${percentY}%`;

    Zoom.zoomAnimationFrame = null; // Libera a próxima execução do requestAnimationFrame
  });
} 

// Controla o estado do zoom, eventos de mudança e movimento do mouse
export function setZoomControl() {
  const { targetImagesSlider } = Zoom;
  const gallery = targetImagesSlider.swiper;
  const galleryElement = targetImagesSlider.element;
  if (!gallery) return; // Sai se o Swiper não estiver inicializado

  // Caso o elemento de swiper não tenha um comportamento de grid, adiciona os tratamentos
  // de slideChangeTransition
  if (!galleryElement.hasAttribute('data-images-grid')) {
    // Remove o pointer events quando inicia a transição da troca de slide
    gallery.on('slideChangeTransitionStart', () => {
      gallery.slides.forEach((slide) => {
        slide.style.pointerEvents = 'none';
        slide.classList.remove('-zoomed');
        slide.classList.remove('-zoom-available');
      })
    })
  
    // Remove o zoom ao trocar de slide manualmente
    gallery.on('slideChangeTransitionEnd', () => {
      gallery.slides.forEach((slide) => {
        slide.style.pointerEvents = 'initial';
        Zoom.isZoomActive = false;
        if (Zoom.zoomOnClick || Zoom.zoomOnHover) {
          !slide.hasAttribute('data-main-video') && slide.classList.add('-zoom-available');
        }
      });
    });
  } 

  // Acompanha o movimento do mouse para mover a imagem ampliada - somente desktop
  !window.mobile && gallery.slides.length > 0 && gallery.slides.forEach((slide) => {
    slide.addEventListener('mousemove', (event) => {
      if (slide.classList.contains('-zoomed') && Zoom.isZoomActive) {
        const zoomContainer = slide.querySelector('.swiper-zoom-container');
        const zoomedImage = slide.querySelector('.swiper-zoom-target');
        if (!zoomContainer || !zoomedImage) return;
        handleMouseMoveZoom(event, zoomContainer, zoomedImage); 
      }
    });
  });
   
}

// Tratamento que troca o src da imagem utilizando o resize adequado para o zoom
export function handleZoomImageSources(image) {
  if (!image || !image.getAttribute('data-zoom-src')) return;

  const slide = image.closest('.swiper-slide');
  if (!slide) return;

  const zoomUrl = image.getAttribute('data-zoom-src');
  if (slide.classList.contains('-zoomed')) {
    image.src = zoomUrl;
    image.removeAttribute('srcset');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-zoom-src');
    Zoom.targetImagesSlider.swiper.update();
  }
}
